import { RouteConfig } from 'vue-router'
import Layout from '@/layout/index.vue'

import trade from './trade'
import tradeAndroid from './trade-android'

// 交易系统一级
const tradeRouter: RouteConfig = {
  path: '/trade',
  component: Layout,
  redirect: '/trade-ios',
  meta: {
    title: 'VIP',
    icon: 'menu-files'
  },
  children: [
    trade,
    tradeAndroid,
    {
      name: 'TradeGame',
      path: 'trade-game',
      component: () => import('@/views/trade/trade-game/index.vue'),
      meta: {
        title: '联运游戏订单',
        showTitle: true
      }
    }, {
      name: 'TradeTubi',
      path: 'trade-tubi',
      component: () => import('@/views/trade/trade-tubi/index.vue'),
      meta: {
        title: '兔币订单',
        showTitle: true
      }
    }, {
      name: 'TradeExchange',
      path: 'trade-exchange',
      component: () => import('@/views/trade/trade-exchange/index.vue'),
      meta: {
        title: '汇率设置',
        showTitle: true
      }
    }
  ]
}

export default tradeRouter
